<!--
 * @Descripttion: 绩效金/提成设置
 * @version: 
 * @Author: alex.yang
 * @Date: 2023-12-19 17:43:46
 * @LastEditors: alex.yang
 * @LastEditTime: 2023-12-22 15:41:28
-->
<template>
    <div class="royaltySetting">
        <div class="rs-title">
            <div class="mt-title">绩效金提成管理</div>
            <div class="mt-add">
                <div class="type">
                    <div class="tag">客服人员</div>
                    <el-select @change="changeSelect" v-model="serviceValue" placeholder="请选择">
                        <el-option
                        v-for="item in serviceOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="add" @click="clickSave">保存</div>
            </div>
        </div>
        <!-- 绩效金办法 -->
        <div class="rs-jxj-box">
            <div class="rjb-title">
                <div class="r-t-left">客服部<span>绩效金办法</span></div>
            </div>
            <div class="rjb-box">
                <div class="r-b-left">
                    <div class="l-item">
                        <div class="title">绩效金基数</div>
                        <el-input v-model="info.performance_base" placeholder="请输入绩效金基数"></el-input>
                        <div class="unit">元</div>
                    </div>
                </div>
                <div class="r-b-right">
                    <img class="img" src="https://ukoo.oss-cn-beijing.aliyuncs.com/system/20231222/26c265542f5a28c0eb54ebdfe2f4fa29.png" />
                </div>
            </div>
        </div>
        <!-- 提成办法 -->
        <div class="rs-jxj-box">
            <div class="rjb-title">
                <div class="r-t-left">客服部<span>提成办法</span></div>
            </div>
            <div class="rjb-box">
                <div class="r-b-left">
                    <div class="l-item">
                        <div class="title">培训反馈数 x</div>
                            <el-input v-model="info.commission" placeholder="请输入数字"></el-input>
                        <div class="unit">元</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/utils/common.js"
import pageMixin from '@/internal/pageMixin'
export default {
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'royaltySetting',
            serviceOptions: [],
            serviceValue: '',
            info: {
                performance_base: '',
                commission: ''
            },
        }
    },
    mounted () {
        this.getServiceWhole()
    },
    methods: {
        // 保存
        clickSave(){
            if(this.info.performance_base == ''){
                this.$message.error('请输入绩效金基数')
                return
            }
            if(this.info.commission == ''){
                this.$message.error('请输入提成数字')
                return
            }
            let params = {
                service_id: this.serviceValue,
                performance_base: this.info.performance_base,
                commission: this.info.commission,
            }
            api.post('/service/service/set_service_performance_commission', params, (res) =>  {
                this.$message.success('设置成功')
                this.getServicePerformance()
            });
        },
        // 获取客服绩效提成
        getServicePerformance(){
            let params = {
                service_id: this.serviceValue
            }
            api.get('/service/service/get_service_performance_commission', params, (res) =>  {
                if(res.data.data){
                    this.info = res.data.data
                }else{
                    let info = {
                        performance_base: '',
                        commission: ''
                    }
                    this.info = info
                }
            });
        },
        // 获取客服人员
        getServiceWhole(){
            api.get('/service/service/get_service_whole', {}, (res) =>  {
                this.serviceOptions = res.data.list;
                this.serviceValue = res.data.list[0].id;
                this.getServicePerformance();
            });
        },
        // 选择客服人员
        changeSelect(){
            this.getServicePerformance();
        },
    },
}
</script>

<style lang='scss'>
.royaltySetting{
    .rs-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 20px 40px;
        .mt-title{
            font-size: 24px;
            color: #101010;
        }
        .mt-add{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .type{
                margin-right: 10px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                .tag{
                    font-size: 16px;
                    color: #101010;
                    margin-right: 15px;
                }
                .el-select{
                    width: 130px;
                }
            }
            .add{
                margin-left: 30px;
                width: 100px;
                height: 38px;
                border-radius: 6px;
                border: 1px solid #0068ff;
                background: #0068ff;
                font-size: 14px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
        }
    }
    .rs-jxj-box{
        background: #fff;
        margin-top: 15px;
        .rjb-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ddd;
            padding: 10px 40px;
            .r-t-left{
                font-size: 18px;
                font-weight: bold;
                span{
                    font-weight: 400;
                    margin-left: 10px;
                }
            }
            .r-t-right{
                .btn-wrap{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .btn{
                        width: 100px;
                        height: 35px;
                        border-radius: 6px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 14px;
                        color: #0068ff;
                        border: 1px solid #0068ff;
                        cursor: pointer;
                    }
                    .submit{
                        background: #0068ff;
                        color: #fff;
                        margin-left: 20px;
                    }
                    .n-btn{
                        background: #fff;
                        color: #0068ff;
                        margin-left: 50px;
                        cursor: pointer;
                    }
                }
            }
        }
        .rjb-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 40px;
            .r-b-left{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                .l-item{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    font-size: 16px;
                    color: #101010;
                    margin: 5px 100px 5px 0;
                    .el-input{
                        width: 200px;
                        margin: 0 20px;
                    }
                    .price{
                        font-size: 30px;
                        color: #101010;
                        margin: 0 20px;
                    }
                }
            }
            .r-b-right{
                width: 450px;
                height: 120px;
                background: #eff3f9;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                .img{
                    width: 100%;
                    height: 100%;
                    vertical-align: bottom;
                }
            }
        }
    }
}
</style>
